import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import {
    AppBar as MuiAppBar,
    Badge,
    Box,
    Button,
    IconButton,
    Toolbar,
} from '@mui/material';
import React from 'react';
import inopackLogo from './logo.png';
import { useNavigate } from 'react-router-dom';
import {
    navigateToActivitiesPage,
    useCurrentUserQuery,
    RoleId,
} from '../../../services';
import { useDevState } from '../../../helpers';
import { ColorModeContext } from '../providers/custom-theme-provider';
import { ConnectionStatusIndicator } from './connection-status-indicator';

interface IInopackAppBarProps {
    toggleDrawer: () => void;
}

export const InopackAppBar = (props: IInopackAppBarProps) => {
    const { toggleDrawer } = props;
    const navigate = useNavigate();
    const isDevEnvironment = useDevState();
    const { mode, toggleColorMode } = React.useContext(ColorModeContext);

    const { data: currentUserData } = useCurrentUserQuery();
    const currentUser = currentUserData?.currentUser;
    // Activities is a cross-domain view: Super, General and Asistente General only.
    const canSeeActivities =
        !!currentUser &&
        [RoleId.Super, RoleId.Admin, RoleId.Guest].some((roleId) =>
            currentUser.role_ids.includes(roleId),
        );

    return (
        <MuiAppBar
            className={'no-printable-block'}
            position="fixed"
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                bgcolor: isDevEnvironment ? 'secondary.main' : undefined,
            }}
        >
            <Toolbar
                sx={{
                    pr: '24px', // keep right padding when drawer closed
                }}
            >
                <Box
                    sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}
                >
                    <IconButton aria-label="open drawer" onClick={toggleDrawer}>
                        <MenuIcon />
                    </IconButton>
                    <Button sx={{ p: 0, m: 0 }} size={'small'} onClick={() => navigate('/')}>
                        <Box
                            component={'img'}
                            src={inopackLogo}
                            sx={{
                                maxWidth: '10rem',
                                marginLeft: '4rem',
                                filter: mode === 'dark' ? 'brightness(0) invert(1)' : 'none',
                            }}
                        />
                    </Button>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <ConnectionStatusIndicator />
                    <IconButton onClick={toggleColorMode} title={mode === 'light' ? 'Modo oscuro' : 'Modo claro'}>
                        {mode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
                    </IconButton>
                    {canSeeActivities && (
                        <IconButton
                            onClick={async () => {
                                navigateToActivitiesPage({ navigate });
                            }}
                        >
                            <Badge badgeContent={0} color="error">
                                <NotificationsIcon />
                            </Badge>
                        </IconButton>
                    )}
                </Box>
            </Toolbar>
        </MuiAppBar>
    );
};
